'use client';

import dynamic from 'next/dynamic';

const LoadingAnimation = dynamic(() => import('./loading'), { ssr: false });

export { LoadingAnimation };
